import { LINK } from '@constants';

export const supportMenuList = [
  {
    text: '자주 묻는 질문',
    type: 'faq',
    url: LINK.FAQ,
  },
  {
    text: '공지사항',
    type: 'announcement',
    url: LINK.NOTICE,
  },
  {
    text: '개선 제안하기',
    type: 'suggest',
    url: LINK.SUGGEST,
  },
  {
    text: '제휴 광고 문의하기',
    type: 'contact',
    url: LINK.CONTACT,
  },
];
